// esri.core
import { subclass, property } from "@arcgis/core/core/accessorSupport/decorators";

// esri.widgets
import Widget from "@arcgis/core/widgets/Widget";
import { tsx, messageBundle } from "@arcgis/core/widgets/support/widget";

import { substitute } from "@arcgis/core/intl";

// ----------------------------------
//
//  CSS Classes
//
// ----------------------------------
const CSS = {
  base: "esri-config-panel-unsupported-browser",
  browserIconContainer:
    "esri-config-panel-unsupported-browser__browser-icon-container",
  browserIcon: "esri-config-panel-unsupported-browser__browser-icon",
  messageContainer: "esri-config-panel-unsupported-browser__message-container",
  jsGlobalNav: "js-global-nav",
  globalNav: "global-nav"
};

@subclass("UnsupportedBrowser")
class UnsupportedBrowser extends Widget {
  private _downloadUrls = {
    chrome: "https://www.google.com/chrome/",
    firefox: "https://www.mozilla.org/firefox/new/",
    edge: "https://www.microsoft.com/edge",
    safari: "https://support.apple.com/downloads/safari",
    catsGeoNetLink: "https://community.esri.com/groups/cats",
    edgelegacy:
      "https://support.microsoft.com/en-us/help/4533505/what-is-microsoft-edge-legacy"
  };

  @property()
  @messageBundle("./t9n/UnsupportedBrowser")
  messages: any = null;

  constructor(params?: any) {
    super(params);
  }

  @property()
  isIE = false;

  render() {
    const message = !this.isIE ? this.messages.message : this.messages.ie11Message;
    const { pathname } = window.location;
    const distPath = pathname.substring(0, pathname.lastIndexOf("/"));
    return (
      <div>
        <div class={CSS.messageContainer}>
          <h2>{this.messages.title}</h2>
          <div innerHTML={substitute(message, this._downloadUrls)} />
          <div class={CSS.browserIconContainer}>
            <img
              class={CSS.browserIcon}
              src={`${distPath}/assets/images/chrome.jpg`}
              alt="Google Chrome Icon"
            />
            <img
              class={CSS.browserIcon}
              src={`${distPath}/assets/images/firefox.jpg`}
              alt="Mozilla Firefox Icon"
            />
            <img
              class={CSS.browserIcon}
              src={`${distPath}/assets/images/safari.jpg`}
              alt="Safari Icon"
            />
            {!this.isIE ? (
              <img
                class={CSS.browserIcon}
                src={`${distPath}/assets/images/new_edge.jpg`}
                alt="Chromium Edge Icon"
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default UnsupportedBrowser;
